(() => {
  const readJson = (node, fallback = {}) => {
    try { return JSON.parse(node?.textContent || '{}'); } catch { return fallback; }
  };
  const labels = () => readJson(document.getElementById('fva-i18n'));
  const format = (s, values) => Object.entries(values).reduce((text, [key, value]) => text.replaceAll(`{{ ${key} }}`, value).replaceAll(`{{${key}}}`, value), s || '');
  const wireTabs = (buttons, apply) => {
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => apply(button));
      button.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        apply(buttons[next]);
        buttons[next].focus();
      });
    });
  };
  const initLanguage = () => {
    document.querySelectorAll('.fva-language-form').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', () => {
        const returnTo = form.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
      });
    });
  };
  const initHeader = () => {
    document.querySelectorAll('.fva-chrome header').forEach(header => {
      if (header.dataset.ready) return;
      header.dataset.ready = 'true';
      const toggle = header.querySelector('.menu-toggle');
      const nav = header.querySelector('nav');
      if (!toggle || !nav) return;
      const close = () => { toggle.setAttribute('aria-expanded', 'false'); nav.classList.remove('open'); };
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        nav.classList.toggle('open', open);
      });
      nav.addEventListener('click', event => { if (event.target.closest('a')) close(); });
      header.addEventListener('keydown', event => { if (event.key === 'Escape') { close(); toggle.focus(); } });
    });
  };
  const initHome = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const ui = labels();
    const stages = readJson(root.querySelector('[data-fva-stages]'));
    const stageButtons = [...root.querySelectorAll('[data-stage]')];
    wireTabs(stageButtons, button => {
      const stage = stages[button.dataset.stage];
      if (!stage) return;
      stageButtons.forEach(tab => { const selected = tab === button; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; });
      root.querySelector('#stage-title').textContent = stage.title;
      root.querySelector('#stage-description').textContent = stage.description;
      const image = root.querySelector('#stage-image');
      image.src = stage.image;
      image.alt = stage.alt;
      root.querySelector('#stage-caption').textContent = stage.caption;
      root.querySelector('#journey-panel').setAttribute('aria-labelledby', button.id);
    });
    const items = [...root.querySelectorAll('.gallery-item')];
    const filters = [...root.querySelectorAll('[data-filter]')];
    const more = root.querySelector('#gallery-more');
    let category = 'all';
    let expanded = false;
    const draw = () => {
      const matching = items.filter(item => category === 'all' || item.dataset.category === category);
      items.forEach(item => { item.hidden = !matching.includes(item) || (!expanded && matching.indexOf(item) >= 6); });
      filters.forEach(button => { const selected = button.dataset.filter === category; button.classList.toggle('active', selected); button.setAttribute('aria-pressed', String(selected)); });
      if (more) {
        more.hidden = matching.length <= 6;
        more.setAttribute('aria-expanded', String(expanded));
        more.replaceChildren(document.createTextNode(expanded ? ui.show_fewer_photos : ui.show_all_photos));
        const arrow = document.createElement('span'); arrow.setAttribute('aria-hidden', 'true'); arrow.textContent = expanded ? '↑' : '↓'; more.append(arrow);
      }
      const count = root.querySelector('#gallery-count');
      if (count) count.textContent = format(ui.photo_count, {count:expanded ? matching.length : Math.min(6, matching.length), total:matching.length});
    };
    filters.forEach(button => button.addEventListener('click', () => { category = button.dataset.filter; expanded = false; draw(); }));
    more?.addEventListener('click', () => { expanded = !expanded; draw(); });
    draw();
    const dialog = root.querySelector('#photo-dialog');
    if (dialog) {
      items.forEach(item => item.addEventListener('click', () => {
        const original = item.querySelector('img');
        const enlarged = dialog.querySelector('#dialog-image');
        if (!original || !enlarged) return;
        enlarged.src = original.currentSrc || original.src;
        enlarged.alt = original.alt;
        dialog.querySelector('#dialog-caption').textContent = item.dataset.caption || original.alt;
        dialog.showModal();
      }));
      dialog.querySelector('#close-dialog')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close(); } });
    }
  };
  const initCards = root => {
    root.querySelectorAll('[data-card-variant]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const card = select.closest('.shop-card');
        const option = select.selectedOptions[0];
        const ui = labels();
        card.querySelector('.price').textContent = option.dataset.money;
        card.dataset.price = option.dataset.price;
        card.dataset.available = option.dataset.available;
        const available = option.dataset.available === 'true';
        card.querySelector('.availability-badge').textContent = available ? ui.available : ui.sold_out;
        const link = card.querySelector('.buy-link');
        const url = new URL(link.href); url.searchParams.set('variant', option.value); link.href = url.pathname + url.search;
        link.classList.toggle('unavailable', !available);
        link.querySelector('b').textContent = available ? ui.view_coffee : ui.view_availability;
        root.dispatchEvent(new CustomEvent('fva:variant-change'));
      });
    });
  };
  const initCatalog = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const ui = labels();
    const grid = root.querySelector('#products-grid');
    const cards = [...grid.querySelectorAll('.shop-card')];
    const search = root.querySelector('#product-search');
    const form = root.querySelector('#form-filter');
    const sort = root.querySelector('#product-sort');
    const available = root.querySelector('#available-only');
    const processes = [...root.querySelectorAll('[data-process]')].filter(node => node.tagName === 'BUTTON');
    const url = new URL(location.href);
    let process = ['honey','lavado','natural'].includes(url.searchParams.get('proceso')) ? url.searchParams.get('proceso') : 'all';
    if (['grano','molido','verde'].includes(url.searchParams.get('presentacion'))) form.value = url.searchParams.get('presentacion');
    const clean = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const rank = card => ({grano:0,molido:3,verde:6}[card.dataset.form] ?? 90) + ({honey:0,lavado:1,natural:2}[card.dataset.process] ?? 9);
    const draw = () => {
      const term = clean(search.value.trim());
      const list = [...cards].sort((a,b) => {
        if (sort.value === 'price-low') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort.value === 'price-high') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort.value === 'name') return a.dataset.name.localeCompare(b.dataset.name,document.documentElement.lang || 'es');
        return rank(a) - rank(b);
      });
      let count=0;
      list.forEach(card => {
        card.hidden = (process !== 'all' && card.dataset.process !== process) || (form.value !== 'all' && card.dataset.form !== form.value) || (available.checked && card.dataset.available !== 'true') || !clean(card.textContent).includes(term);
        if (!card.hidden) count++;
        grid.append(card);
      });
      processes.forEach(button => {
        const selected = button.dataset.process === process;
        button.classList.toggle('selected', selected); button.setAttribute('aria-pressed', String(selected));
        const countNode=button.querySelector('span');
        if(countNode) countNode.textContent=cards.filter(card=>button.dataset.process==='all'||card.dataset.process===button.dataset.process).length;
      });
      root.querySelector('#result-count').textContent = format(count === 1 ? ui.coffee_count_one : ui.coffee_count,{count});
      root.querySelector('#empty-results').hidden = count > 0;
    };
    processes.forEach(button => button.addEventListener('click',()=>{ process=button.dataset.process; draw(); }));
    search.addEventListener('input',draw);
    [form,sort,available].forEach(input=>input.addEventListener('change',draw));
    root.addEventListener('fva:variant-change',draw);
    root.querySelector('#reset-filters')?.addEventListener('click',()=>{process='all';search.value='';form.value='all';sort.value='recommended';available.checked=false;draw();});
    root.querySelectorAll('[data-form-shortcut]').forEach(button=>button.addEventListener('click',()=>{form.value=button.dataset.formShortcut;process='all';search.value='';available.checked=false;draw();root.querySelector('#coleccion').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));
    draw();
    initCards(root);
  };
  const initProduct = root => {
    if (root.dataset.ready) return;
    root.dataset.ready='true';
    const ui=labels();
    const mainPhoto=root.querySelector('.product-visual > img');
    const initialPhoto=mainPhoto?{src:mainPhoto.currentSrc||mainPhoto.src,alt:mainPhoto.alt}:null;
    const presentation = root.querySelector('.presentation-options');
    if (presentation) [...presentation.children].sort((a,b) => { const rank = link => /en grano|whole bean/i.test(link.textContent) ? 0 : /molido|ground/i.test(link.textContent) ? 1 : 2; return rank(a)-rank(b); }).forEach(link => presentation.append(link));
    const photoButtons=[...root.querySelectorAll('.product-photo-tabs button')];
    photoButtons.forEach(button=>button.addEventListener('click',()=>{
      if(!mainPhoto)return;
      mainPhoto.removeAttribute('srcset');mainPhoto.removeAttribute('sizes');
      mainPhoto.src=button.hasAttribute('data-product-photo')?initialPhoto.src:button.dataset.photo;
      mainPhoto.alt=button.hasAttribute('data-product-photo')?initialPhoto.alt:button.dataset.alt;
      photoButtons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    }));
    root.querySelectorAll('[data-quantity-step]').forEach(button=>button.addEventListener('click',()=>{
      const input=button.closest('.quantity-control').querySelector('input');
      const current=Number(input.value)||Number(input.min)||1;
      input.value=String(Math.max(Number(input.min)||1,current+Number(button.dataset.quantityStep)));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    const variant=root.querySelector('[data-product-variant]');
    variant?.addEventListener('change',()=>{
      const option=variant.selectedOptions[0];const available=option.dataset.available==='true';
      root.querySelector('#product-price').textContent=option.dataset.money;
      root.querySelector('#product-stock').textContent=available?ui.available:ui.sold_out;
      root.querySelector('#product-stock').dataset.soldOut=String(!available);
      const submit=root.querySelector('[data-product-submit]');submit.disabled=!available;submit.querySelector('.purchase-text').textContent=available?ui.add_to_cart:ui.sold_out;
      const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
    });
    const brewButtons=[...root.querySelectorAll('[data-brew]')];
    wireTabs(brewButtons,button=>{
      const template=root.querySelector(`[data-brew-template="${button.dataset.brew}"]`);
      if(!template)return;
      brewButtons.forEach(b=>{const selected=b===button;b.setAttribute('aria-selected',String(selected));b.tabIndex=selected?0:-1;});
      const metrics=template.content.querySelector('[data-brew-metrics]');
      const steps=template.content.querySelector('[data-brew-steps]');
      const source=template.content.querySelector('[data-brew-source]');
      root.querySelector('.brew-metrics').replaceChildren(...[...metrics.childNodes].map(node=>node.cloneNode(true)));
      root.querySelector('#brew-steps').replaceChildren(...[...steps.childNodes].map(node=>node.cloneNode(true)));
      root.querySelector('#brew-source').replaceChildren(...[...source.childNodes].map(node=>node.cloneNode(true)));
      root.querySelector('#brew-panel').setAttribute('aria-labelledby',button.id);
    });
    initCards(root);
  };
  const init=()=>{
    initLanguage();
    initHeader();
    document.querySelectorAll('[data-fva-home]').forEach(initHome);
    document.querySelectorAll('[data-fva-catalog]').forEach(initCatalog);
    document.querySelectorAll('[data-fva-product]').forEach(initProduct);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
